import formEmbeddableMixin from "@/mixins/embeddable/resource/formEmbeddableMixin"
import ProductionOrderStepFormEmbeddable from "@/views/modules/production/ProductionOrder/embeddable/ProductionOrderStepFormEmbeddable"
import ProductionOrderStepEntity from "@/model/entities/modules/production/ProductionOrderStepEntity";


export default {
    components: {ProductionOrderStepFormEmbeddable},
    mixins: [formEmbeddableMixin],
    data() {
        return {
            path: "production/order-step", //Override somente de front-end, por tanto irá utilizar o mesmo path que o original da página 56
            form: {},//DEVERÁ SER ATRIBUIDO NO MOUNTED DEVIDO A ENTIDADE RELACIONADA EVITANDO PERISTÊNCIA DOS DADOS INDEVIDA
        }

    },
    async mounted() {

        this.form = ProductionOrderStepEntity

    },
    methods: {}
}